//import logo from "./logo.svg";
import "./App.css";
import { IconMov } from "./components/icons-anim/Icon";
import { TextChange } from "./components/text-change/Textchange";
import { MainTitle } from "./components/main-title/MainTitle";
import { Link } from "react-router-dom";

function App() {
  return (
    <div>
      {/** Nav Menu */}
      <div class="nav-menu fixed-top">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <nav class="navbar navbar-dark navbar-expand-lg">
                <Link class="navbar-brand" to='/'>
                  <img src="images/logo.png" class="img-fluid" alt="logo" />
                </Link>
                <button
                  class="navbar-toggler"
                  type="button"
                  data-toggle="collapse"
                  data-target="#navbar"
                  aria-controls="navbar"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="navbar">
                  <ul class="navbar-nav ml-auto">
                    <li class="nav-item">
                      <a class="nav-link active" href="#home">
                        HOME <span class="sr-only">(current)</span>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" href="#features">
                        FEATURES
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" href="#gallery">
                        GALLERY
                      </a>
                    </li>
                    {/**<li class="nav-item">
                      <a class="nav-link" href="#pricing">
                        PRICING
                      </a>
                    </li>*/}
                    <li class="nav-item">
                      <a class="nav-link" href="#contact">
                        CONTACT
                      </a>
                    </li>
                    {/**<li class="nav-item"><a href="#" class="btn btn-outline-light my-3 my-sm-0 ml-lg-3">Download</a></li>*/}
                  </ul>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>

      <header class="bg-gradient" id="home">
        <div class="container mt-5">
          <MainTitle />
          <p class="tagline">
            The next AI software products. With a touch of finesse art and
            creativity.
          </p>
        </div>
        <div
          style={{
            display: "flex",
            width: "100%",
            flexDirection: "column",
            alignItems: "center",
            justifyItems: "center",
            justifySelf: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              width: "80%",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              justifyItems: "center",
            }}
          >
            <div>
              <div class="container">
                <div class="call-to-action">
                  <img
                    src={"images/iconapp.png"}
                    class="icon-app-logo"
                    alt="app icon"
                  />
                  {/*<h3>Download Anywhere</h3>*/}
                  <div class="my-4"></div>
                  <p class="tagline">
                    Available for all major mobile platforms. AI software to
                    learn German; powered by Next Super AI Models.
                  </p>
                  <div class="my-4">
                    <a href="#" class="btn btn-light">
                      <img src="images/appleicon.png" alt="icon" /> App Store
                    </a>
                    <a
                      href="#"
                      class="btn btn-light"
                      onClick={() => {
                        console.log("play store");
                      }}
                    >
                      <img src="images/playicon.png" alt="icon" /> Google play
                    </a>
                  </div>
                  <p class="text-primary">
                    <small>
                      <i>
                        *Works on iOS 13.0+, Android 10.0+, iPad, and Tablets.
                      </i>
                    </small>
                  </p>
                </div>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "centent",
                alignItems: "center",
              }}
            >
              <div class="img-holder">
                <img src="images/apps_hola.png" alt="phone" class="img-fluid" />
                {/*<img src="images/screenapp1.png" alt="phone" class="img-fluid"/>* 350 x 701*/}
              </div>
              <div class="container mt-3">
                <div
                  class="tagline"
                  style={{ display: "flex", flexDirection: "row" }}
                >
                  Try our first
                  <TextChange />, Next Flash Talk.
                </div>
              </div>
              <div>
                <p class="tagline" style={{ fontSize: 18 }}>
                  Our own custom AI models powered by:
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  background: "transparent",
                  justifyContent: "space-between",
                  alignContent: "space-between",
                  gap: "30px",
                  marginLeft: "30px",
                }}
              >
                <IconMov imageUrl={"images/gemini-ai-100.png"} />
                <IconMov imageUrl={"images/chatgpt-100.png"} />
                <IconMov imageUrl={"images/ratlosigkeit-ai-100.png"} />
              </div>
            </div>
          </div>
        </div>
      </header>

      <div class="client-logos my-5">
        <div
          class="container text-center"
          style={{ display: "flex", gap: "50px" }}
        >
          {["images/htw_single.png", "images/logo_unsa.png"].map((logoUrl) => {
            return (
              <img
                src={logoUrl}
                alt="client logos"
                class="img-fluid"
                height={"200px"}
                width={"200px"}
              />
            );
          })}
        </div>
      </div>

      <div class="section light-bg" id="features">
        <div class="container">
          <div class="section-title">
            <small>HIGHLIGHTS</small>
            <h3>Features you love</h3>
          </div>

          <div class="row">
            <div class="col-12 col-lg-4">
              <div class="card features">
                <div class="card-body">
                  <div class="media">
                    <span class="ti-face-smile gradient-fill ti-3x mr-3"></span>
                    <div class="media-body">
                      <h4 class="card-title">Simple</h4>
                      <p class="card-text">
                        Next Flash Talk app is designed to be friendly and easy
                        to use without being lost navigating the app.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-4">
              <div class="card features">
                <div class="card-body">
                  <div class="media">
                    <span class="ti-thought gradient-fill ti-3x mr-3"></span>
                    <div class="media-body">
                      <h4 class="card-title">AI</h4>
                      <p class="card-text">
                        Next Flash Talk is designed to learn your habits and
                        understand your progress. So it provides insigths about
                        your learning process and compare it against others
                        learners.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-4">
              <div class="card features">
                <div class="card-body">
                  <div class="media">
                    <span class="ti-settings gradient-fill ti-3x mr-3"></span>
                    <div class="media-body">
                      <h4 class="card-title">Customize</h4>
                      <p class="card-text">
                        Customize to your own level of understandin in German
                        and improve from there.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/** // end .section */}
      {/**
      <div class="section">
        <div class="container">
          <div class="row">
            <div class="col-lg-6 offset-lg-6">
              <div class="box-icon">
                <span class="ti-mobile gradient-fill ti-3x"></span>
              </div>
              <h2>Discover our App</h2>
              <p class="mb-4">
                Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                Obcaecati vel exercitationem eveniet vero maxime ratione
              </p>
              <a href="#" class="btn btn-primary">
                Read more
              </a>
            </div>
          </div>
          <div class="perspective-phone">
            <img
              src="images/perspective.png"
              alt="perspective phone"
              class="img-fluid"
            />
          </div>
        </div>
      </div>
      */}
      {/** // end .section */}

      {/** 
      <div class="section light-bg">
        <div class="container">
          <div class="section-title">
            <small>FEATURES</small>
            <h3>Do more with our app</h3>
          </div>

          <ul class="nav nav-tabs nav-justified" role="tablist">
            <li class="nav-item">
              <a
                class="nav-link active"
                data-toggle="tab"
                href="#communication"
              >
                Communication
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" data-toggle="tab" href="#schedule">
                Scheduling
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" data-toggle="tab" href="#messages">
                Messages
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" data-toggle="tab" href="#livechat">
                Live Chat
              </a>
            </li>
          </ul>
          <div class="tab-content">
            <div class="tab-pane fade show active" id="communication">
              <div class="d-flex flex-column flex-lg-row">
                <img
                  src="images/graphic.png"
                  alt="graphic"
                  class="img-fluid rounded align-self-start mr-lg-5 mb-5 mb-lg-0"
                />
                <div>
                  <h2>Communicate with ease</h2>
                  <p class="lead">
                    Uniquely underwhelm premium outsourcing with proactive
                    leadership skills.
                  </p>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Integer rutrum, urna eu pellentesque pretium, nisi nisi
                    fermentum enim, et sagittis dolor nulla vel sapien.
                    Vestibulum sit amet mattis ante. Ut placerat dui eu nulla
                    congue tincidunt ac a nibh. Mauris accumsan pulvinar lorem
                    placerat volutpat. Praesent quis facilisis elit. Sed
                    condimentum neque quis ex porttitor,
                  </p>
                  <p>
                    malesuada faucibus augue aliquet. Sed elit est, eleifend sed
                    dapibus a, semper a eros. Vestibulum blandit vulputate
                    pharetra. Phasellus lobortis leo a nisl euismod, eu faucibus
                    justo sollicitudin. Mauris consectetur, tortor sed tempor
                    malesuada, sem nunc porta augue, in dictum arcu tortor id
                    turpis. Proin aliquet vulputate aliquam.
                  </p>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="schedule">
              <div class="d-flex flex-column flex-lg-row">
                <div>
                  <h2>Scheduling when you want</h2>
                  <p class="lead">
                    Uniquely underwhelm premium outsourcing with proactive
                    leadership skills.
                  </p>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Integer rutrum, urna eu pellentesque pretium, nisi nisi
                    fermentum enim, et sagittis dolor nulla vel sapien.
                    Vestibulum sit amet mattis ante. Ut placerat dui eu nulla
                    congue tincidunt ac a nibh. Mauris accumsan pulvinar lorem
                    placerat volutpat. Praesent quis facilisis elit. Sed
                    condimentum neque quis ex porttitor,
                  </p>
                  <p>
                    malesuada faucibus augue aliquet. Sed elit est, eleifend sed
                    dapibus a, semper a eros. Vestibulum blandit vulputate
                    pharetra. Phasellus lobortis leo a nisl euismod, eu faucibus
                    justo sollicitudin. Mauris consectetur, tortor sed tempor
                    malesuada, sem nunc porta augue, in dictum arcu tortor id
                    turpis. Proin aliquet vulputate aliquam.
                  </p>
                </div>
                <img
                  src="images/graphic.png"
                  alt="graphic"
                  class="img-fluid rounded align-self-start mr-lg-5 mb-5 mb-lg-0"
                />
              </div>
            </div>
            <div class="tab-pane fade" id="messages">
              <div class="d-flex flex-column flex-lg-row">
                <img
                  src="images/graphic.png"
                  alt="graphic"
                  class="img-fluid rounded align-self-start mr-lg-5 mb-5 mb-lg-0"
                />
                <div>
                  <h2>Realtime Messaging service</h2>
                  <p class="lead">
                    Uniquely underwhelm premium outsourcing with proactive
                    leadership skills.
                  </p>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Integer rutrum, urna eu pellentesque pretium, nisi nisi
                    fermentum enim, et sagittis dolor nulla vel sapien.
                    Vestibulum sit amet mattis ante. Ut placerat dui eu nulla
                    congue tincidunt ac a nibh. Mauris accumsan pulvinar lorem
                    placerat volutpat. Praesent quis facilisis elit. Sed
                    condimentum neque quis ex porttitor,
                  </p>
                  <p>
                    malesuada faucibus augue aliquet. Sed elit est, eleifend sed
                    dapibus a, semper a eros. Vestibulum blandit vulputate
                    pharetra. Phasellus lobortis leo a nisl euismod, eu faucibus
                    justo sollicitudin. Mauris consectetur, tortor sed tempor
                    malesuada, sem nunc porta augue, in dictum arcu tortor id
                    turpis. Proin aliquet vulputate aliquam.
                  </p>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="livechat">
              <div class="d-flex flex-column flex-lg-row">
                <div>
                  <h2>Live chat when you needed</h2>
                  <p class="lead">
                    Uniquely underwhelm premium outsourcing with proactive
                    leadership skills.
                  </p>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Integer rutrum, urna eu pellentesque pretium, nisi nisi
                    fermentum enim, et sagittis dolor nulla vel sapien.
                    Vestibulum sit amet mattis ante. Ut placerat dui eu nulla
                    congue tincidunt ac a nibh. Mauris accumsan pulvinar lorem
                    placerat volutpat. Praesent quis facilisis elit. Sed
                    condimentum neque quis ex porttitor,
                  </p>
                  <p>
                    malesuada faucibus augue aliquet. Sed elit est, eleifend sed
                    dapibus a, semper a eros. Vestibulum blandit vulputate
                    pharetra. Phasellus lobortis leo a nisl euismod, eu faucibus
                    justo sollicitudin. Mauris consectetur, tortor sed tempor
                    malesuada, sem nunc porta augue, in dictum arcu tortor id
                    turpis. Proin aliquet vulputate aliquam.
                  </p>
                </div>
                <img
                  src="images/graphic.png"
                  alt="graphic"
                  class="img-fluid rounded align-self-start mr-lg-5 mb-5 mb-lg-0"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      */}
      {/** // end .section */}

      {/**
      <div class="section">
        <div class="container">
          <div class="row">
            <div class="col-md-6">
              <img
                src="images/dualphone.png"
                alt="dual phone"
                class="img-fluid"
              />
            </div>
            <div class="col-md-6 d-flex align-items-center">
              <div>
                <div class="box-icon">
                  <span class="ti-rocket gradient-fill ti-3x"></span>
                </div>
                <h2>Launch your App</h2>
                <p class="mb-4">
                  Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                  Obcaecati vel exercitationem eveniet vero maxime ratione
                </p>
                <a href="#" class="btn btn-primary">
                  Read more
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      */}
      {/** // end .section */}

      <div class="section light-bg">
        <div class="container">
          <div class="row">
            <div class="col-md-8 d-flex align-items-center">
              <ul class="list-unstyled ui-steps">
                <li class="media">
                  <div class="circle-icon mr-4">1</div>
                  <div class="media-body">
                    <h5>Create an Account?</h5>
                    <p>
                      Not really! You just install the app and start learning.
                      However, we recommend to create an account if you need to
                      keep track your learning process.
                    </p>
                  </div>
                </li>
                <li class="media my-4">
                  <div class="circle-icon mr-4">2</div>
                  <div class="media-body">
                    <h5>Enjoy learning German</h5>
                    <p>
                      Next Flash Talk is designed to understand your learning
                      habits so it will test your knowledge with similar words
                      that you already know or new words according to the
                      context of your learning and the words.
                    </p>
                  </div>
                </li>
                <li class="media">
                  <div class="circle-icon mr-4">3</div>
                  <div class="media-body">
                    <h5>Share with friends</h5>
                    <p>
                      Share it with your friends and challenge among each other
                      or you can challenge yourself with our AI tests. There are
                      people who claimed they learned German in 3 months.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <div class="col-md-4">
              <img src="images/apps.png" alt="iphone" class="img-fluid" />
            </div>
          </div>
        </div>
      </div>
      {/** // end .section */}

      <div class="section">
        <div class="container">
          <div class="section-title">
            <small>TESTIMONIALS</small>
            <h3>What our Customers Says</h3>
          </div>
          <div class="testimonials owl-carousel">
            <div class="testimonials-single">
              {/*<img src="images/client.png" alt="client" class="client-img" />*/}
              <blockquote class="blockquote">
                Among many apps, Next flask Talk app helps me to understand
                better my learning process and it is very intuitive.
              </blockquote>
              <h5 class="mt-4 mb-2">Nayyer Ahmed</h5>
              <p class="text-primary">Berlin, Germany</p>
            </div>
            {/* <div class="testimonials-single">
              <img src="images/client.png" alt="client" class="client-img" />
              <blockquote class="blockquote">
                Uniquely streamline highly efficient scenarios and 24/7
                initiatives. Conveniently embrace multifunctional ideas through
                proactive customer service. Distinctively conceptualize 2.0
                intellectual capital via user-centric partnerships.
              </blockquote>
              <h5 class="mt-4 mb-2">Crystal Gordon</h5>
              <p class="text-primary">United States</p>
            </div>
            <div class="testimonials-single">
              <img src="images/client.png" alt="client" class="client-img" />
              <blockquote class="blockquote">
                Uniquely streamline highly efficient scenarios and 24/7
                initiatives. Conveniently embrace multifunctional ideas through
                proactive customer service. Distinctively conceptualize 2.0
                intellectual capital via user-centric partnerships.
              </blockquote>
              <h5 class="mt-4 mb-2">Crystal Gordon</h5>
              <p class="text-primary">United States</p>
            </div>*/}
          </div>
        </div>
      </div>
      {/** // end .section */}

      <div class="section light-bg" id="gallery">
        <div class="container">
          <div class="section-title">
            <small>GALLERY</small>
            <h3>App Screenshots</h3>
          </div>

          <div class="img-gallery owl-carousel owl-theme">
            <img src="images/screenapp1.png" alt="image" />
          </div>
        </div>
      </div>
      {/** // end .section */}

      {/**
      <div class="section" id="pricing">
        <div class="container">
          <div class="section-title">
            <small>PRICING</small>
            <h3>Upgrade to Pro</h3>
          </div>

          <div class="card-deck">
            <div class="card pricing">
              <div class="card-head">
                <small class="text-primary">PERSONAL</small>
                <span class="price">
                  $14<sub>/m</sub>
                </span>
              </div>
              <ul class="list-group list-group-flush">
                <div class="list-group-item">10 Projects</div>
                <div class="list-group-item">5 GB Storage</div>
                <div class="list-group-item">Basic Support</div>
                <div class="list-group-item">
                  <del>Collaboration</del>
                </div>
                <div class="list-group-item">
                  <del>Reports and analytics</del>
                </div>
              </ul>
              <div class="card-body">
                <a href="#" class="btn btn-primary btn-lg btn-block">
                  Choose this Plan
                </a>
              </div>
            </div>
            <div class="card pricing popular">
              <div class="card-head">
                <small class="text-primary">FOR TEAMS</small>
                <span class="price">
                  $29<sub>/m</sub>
                </span>
              </div>
              <ul class="list-group list-group-flush">
                <div class="list-group-item">Unlimited Projects</div>
                <div class="list-group-item">100 GB Storage</div>
                <div class="list-group-item">Priority Support</div>
                <div class="list-group-item">Collaboration</div>
                <div class="list-group-item">Reports and analytics</div>
              </ul>
              <div class="card-body">
                <a href="#" class="btn btn-primary btn-lg btn-block">
                  Choose this Plan
                </a>
              </div>
            </div>
            <div class="card pricing">
              <div class="card-head">
                <small class="text-primary">ENTERPRISE</small>
                <span class="price">
                  $249<sub>/m</sub>
                </span>
              </div>
              <ul class="list-group list-group-flush">
                <div class="list-group-item">Unlimited Projects</div>
                <div class="list-group-item">Unlimited Storage</div>
                <div class="list-group-item">Collaboration</div>
                <div class="list-group-item">Reports and analytics</div>
                <div class="list-group-item">Web hooks</div>
              </ul>
              <div class="card-body">
                <a href="#" class="btn btn-primary btn-lg btn-block">
                  Choose this Plan
                </a>
              </div>
            </div>
          </div>
          {/** // end .pricing 
        </div>
      </div>
      {/** // end .section */}

      {/*}
      <div class="section pt-0">
        <div class="container">
          <div class="section-title">
            <small>FAQ</small>
            <h3>Frequently Asked Questions</h3>
          </div>

          <div class="row pt-4">
            <div class="col-md-6">
              <h4 class="mb-3">Can I try before I buy?</h4>
              <p class="light-font mb-5">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer
                rutrum, urna eu pellentesque pretium, nisi nisi fermentum enim,
                et sagittis dolor nulla vel sapien. Vestibulum sit amet mattis
                ante.
              </p>
              <h4 class="mb-3">What payment methods do you accept?</h4>
              <p class="light-font mb-5">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer
                rutrum, urna eu pellentesque pretium, nisi nisi fermentum enim,
                et sagittis dolor nulla vel sapien. Vestibulum sit amet mattis
                ante.
              </p>
            </div>
            <div class="col-md-6">
              <h4 class="mb-3">Can I change my plan later?</h4>
              <p class="light-font mb-5">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer
                rutrum, urna eu pellentesque pretium, nisi nisi fermentum enim,
                et sagittis dolor nulla vel sapien. Vestibulum sit amet mattis
                ante.
              </p>
              <h4 class="mb-3">Do you have a contract?</h4>
              <p class="light-font mb-5">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer
                rutrum, urna eu pellentesque pretium, nisi nisi fermentum enim,
                et sagittis dolor nulla vel sapien. Vestibulum sit amet mattis
                ante.
              </p>
            </div>
          </div>
        </div>
      </div>
      */}
      {/** // end .section */}

      {/*<div class="section bg-gradient">
        <div class="container">
          <div class="call-to-action">
            <img
              src={"images/iconapp.png"}
              width={80}
              height={80}
              alt="app icon"
            />
            <h2>Download Anywhere</h2>
            <p class="tagline">
              Available for all major mobile and desktop platforms. Rapidiously
              visualize optimal ROI rather than enterprise-wide methods of
              empowerment.
            </p>
            <div class="my-4">
              <a href="#" class="btn btn-light">
                <img src="images/appleicon.png" alt="icon" /> App Store
              </a>
              <a href="#" class="btn btn-light">
                <img src="images/playicon.png" alt="icon" /> Google play
              </a>
            </div>
            <p class="text-primary">
              <small>
                <i>*Works on iOS 10.0.5+, Android Kitkat and above. </i>
              </small>
            </p>
          </div>
        </div>
      </div>
      */}
      {/** // end .section */}

      <div class="light-bg py-5" id="contact">
        <div class="container">
          <div class="row">
            <div class="col-lg-6 text-center text-lg-left">
              <p class="mb-2">
                <span class="ti-location-pin mr-2"></span> Berlin, Germany
              </p>
              <div class="d-block d-sm-inline-block">
                <p class="mb-2">
                  <span class="ti-email mr-2"></span>
                  <a class="mr-4" href="mailto:support@mobileapp.com">
                    support@nextsuperai.com
                  </a>
                </p>
              </div>
              {/**
                    <div class="d-block d-sm-inline-block">
                        <p class="mb-0">
                            <span class="ti-headphone-alt mr-2"></span> <a href="tel:51836362800">518-3636-2800</a>
                        </p>
                    </div>
                    */}
            </div>
            <div class="col-lg-6">
              <div class="social-icons">
                {/**<a href="#"><span class="ti-facebook"></span></a>
                        <a href="#"><span class="ti-twitter-alt"></span></a>
                        <a href="#"><span class="ti-instagram"></span></a>*/}
                <a href="https://de.linkedin.com/company/next-super-ai">
                  <span class="ti-linkedin"></span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/** // end .section */}
      <footer class="my-5 text-center">
        {/** Copyright removal is not prohibited! */}
        {/**< a href="https://colorlib.com">COLORLIB</a> */}
        <p class="mb-2">
          <small>COPYRIGHT © 2025. ALL RIGHTS RESERVED. NEXT SUPER AI</small>
        </p>

        <small>
          <Link to="terms" class="m-2">TERMS OF USE</Link>
          <a href="#" class="m-2">
            PRIVACY
          </a>
        </small>
      </footer>
    </div>
  );
}

export default App;
